import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");

const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchDoctorOpdAppointmentRouters = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS,
) => {
  return axiosInstance.get(EndPoints.DOCTOR_OPD_APPOINTMENT.LIST, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter,
    },
  });
};

export const fetchDoctorOpdAppointmentDetail = (appointment_id) => {
  const url = EndPoints.DOCTOR_OPD_APPOINTMENT.DETAIL + `/${appointment_id}`;

  return axiosInstance.get(url);
};

export const fetchDoctorOpdAppointmentDropdown = (payload) => {
  return axiosInstance.get(EndPoints.DOCTOR_OPD_APPOINTMENT.DROPDOWN, payload);
};

export const createDoctorOpdAppointment = (payload) => {
  return axiosInstance.post(EndPoints.DOCTOR_OPD_APPOINTMENT.CREATE, payload);
};

export const updateDoctorOpdAppointment = (payload) => {
  return axiosInstance.put(EndPoints.DOCTOR_OPD_APPOINTMENT.UPDATE, payload);
};

export const deleteDoctorOpdAppointment = (payload) => {
  const url = EndPoints.DOCTOR_OPD_APPOINTMENT.DELETE + `/${payload}`;
  return axiosInstance.delete(url);
};

export const downloadDoctorOpdAppointmentCSV = () => {
  return axiosInstance.put(
    EndPoints.DOCTOR_OPD_APPOINTMENT.DOWNLOAD_CSV,
    {},
    {
      responseType: "blob",
    },
  );
};
